var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid no-gutters px-0 pt-0 pb-0 border-bottom toolbars-bg",staticStyle:{"z-index":"30000"}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }